<template>
  <transition name="fade">
    <div class="popup tips-popup" v-if="popupState.history">
      <div class="popup-mask fade-in" @click="hidePopup"></div>
      <div class="popup-main">
        <a
          href="javascript:void(0);"
          class="popup-main-close"
          @click="hidePopup"
        ></a>
        <p class="popupTips">{{ $t('hasHistory') }}</p>
        <p class="popupTips">{{ $t('loadHistory') }}</p>
        <div class="btn-wrap">
          <a href="javascript:void(0)" class="btn cancel" @click="hidePopup">{{
            $t('cancel')
          }}</a>
          <a
            href="javascript:void(0)"
            class="btn confirm"
            @click="recoverData"
            >{{ $t('confirm') }}</a
          >
        </div>
      </div>
    </div>
  </transition>
</template>

<script lang="ts" setup>
import popupHook from '@/hooks/popupHook';
const { popupState, hidePopup, recoverData } = popupHook();
</script>

<style lang="scss" scoped></style>
